'use client'

import { BiLinkAlt, BiSolidCake } from 'react-icons/bi'

import { maplePeachy } from '@/app/fonts'
import { Button, RotativeIcon } from '@/components'
import { allFillings } from '@/components/CakeMaker/data/fillings'
import { STARTING_PRICE } from '@/config/constants'
import { useBreakpoints } from '@/hooks'

import './styles.scss'

export default function Hero() {
  const { isSemiMedium } = useBreakpoints()

  const scrollToCakeMaker = () => {
    const section = document.querySelector('section#cake-maker')
    if (!section) return

    setTimeout(() => {
      requestAnimationFrame(() => {
        section.scrollIntoView({
          inline: 'start',
          behavior: 'smooth',
          block: 'start',
        })
      })
    }, 50)
  }

  return (
    <div className="hero-wrapper">
      <section className="hero container" id="hero">
        <div className="content">
          {/* Elementos de bloco (div/p) não são válidos dentro de um heading —
              só conteúdo de frase. Usamos span com display:block no CSS para
              manter o mesmo layout com marcação válida. */}
          <h1 className="title">
            <span style={maplePeachy.style} className="common-title-text">
              Sua confeitaria de
            </span>

            <span className="same-row">
              <span className="rotate-text">
                <span style={maplePeachy.style} className="colorful-title-text">
                  Bolos
                  <br />
                  Brigadeiros
                  <br />
                  Brownies
                </span>
              </span>
            </span>

            <span className="same-row">
              <span className="rotate-icon-wrapper" aria-hidden>
                <RotativeIcon size="var(--icon-size)" />
              </span>

              <span style={maplePeachy.style} className="common-title-text">
                artesanais
                <span style={maplePeachy.style} className="colorful-title-text">
                  !
                </span>
              </span>
            </span>
          </h1>

          <p className="subtitle">
            A <strong>Sancta Fatia</strong> é uma confeitaria artesanal no
            Parque do Carmo, na Zona Leste de São Paulo. Monte seu bolo
            confeitado com {allFillings.length} recheios, a partir de{' '}
            <strong>{STARTING_PRICE.DISPLAY}</strong>, e receba em casa.
          </p>

          <div className="buttons-container">
            <Button
              onClick={scrollToCakeMaker}
              containerClassName="order-button"
              text="Quero encomendar!"
              variant="primary"
              aria-label="Ir para a seção de encomenda de bolo"
              rightRender={
                <BiSolidCake
                  size={isSemiMedium ? 16 : 24}
                  color="var(--w1)"
                  aria-hidden
                />
              }
            />

            <Button
              onClick={() => {
                window.open('/menu.pdf', '_blank', 'noopener,noreferrer')
              }}
              containerClassName="pdf-button"
              text="Menu digital"
              variant="primary"
              aria-label="Abrir menu digital em PDF"
              rightRender={
                <BiLinkAlt
                  size={isSemiMedium ? 16 : 24}
                  color="var(--w1)"
                  aria-hidden
                />
              }
            />
          </div>
        </div>
      </section>
      <div className="blur-fx" />
    </div>
  )
}
